

let lenis;

import isMobile from "./is-mobile";

function getLenisConstructor() {
	return window.Lenis || globalThis.Lenis;
}

function getGsap() {
	return window.gsap || globalThis.gsap || null;
}

function getScrollTrigger() {
	return window.ScrollTrigger || globalThis.ScrollTrigger || null;
}

function normalizePathname(pathname = '') {
	return pathname.replace(/\/+$/, '') || '/';
}

function parseSamePageUrl(anchor) {
	const href = anchor.getAttribute('href');

	if (!href || href === '#') {
		return null;
	}

	try {
		const url = new URL(anchor.href, window.location.href);
		const isSamePage =
			url.origin === window.location.origin &&
			normalizePathname(url.pathname) === normalizePathname(window.location.pathname) &&
			url.search === window.location.search;

		return isSamePage ? url : null;
	} catch (error) {
		return null;
	}
}

function getAnchorTargetElement(hashTarget) {
	if (!hashTarget || hashTarget === '#') {
		return null;
	}

	const targetId = decodeURIComponent(hashTarget.slice(1));

	if (document.getElementById(targetId)) {
		return document.getElementById(targetId);
	}

	try {
		return document.querySelector(hashTarget);
	} catch (error) {
		return null;
	}
}

function getInPageNavigation(anchor) {
	const samePageUrl = parseSamePageUrl(anchor);

	if (!samePageUrl) {
		return null;
	}

	if (!samePageUrl.hash) {
		return {
			target: 0,
			historyUrl: `${samePageUrl.pathname}${samePageUrl.search}`,
		};
	}

	const targetElement = getAnchorTargetElement(samePageUrl.hash);

	if (!targetElement) {
		return null;
	}

	return {
		target: targetElement,
		historyUrl: samePageUrl.hash,
	};
}

function closeMenusForAnchor(anchor) {
	if (anchor.closest('.menu-wrapper')) {
		document.dispatchEvent(new CustomEvent('cmpth:close-mobile-menu'));
	}

	if (anchor.closest('header.header, .submenus-wrapper-desktop')) {
		document.dispatchEvent(new CustomEvent('cmpth:close-desktop-menu'));
	}
}

export function getLenisScroll(d = document) {
	const LenisConstructor = getLenisConstructor();
	const gsapInstance = getGsap();
	const scrollTriggerInstance = getScrollTrigger();

	if (!LenisConstructor || !gsapInstance || !scrollTriggerInstance) {
		return;
	}

	let content = d.querySelector('.scroller') ? d.querySelector('.scroller') : d
	lenis = new LenisConstructor({
		lerp: 0.1,
		duration: 1.8,
		wrapper: d,
		smooth: true,
		allowNestedScroll: true,
		//infinite:true,
		content: content,
	});

	lenis.on('scroll', scrollTriggerInstance.update);

	gsapInstance.ticker.add(time => {
		lenis.raf(time * 1000);
	});

	gsapInstance.ticker.lagSmoothing(0);

	scrollTriggerInstance.defaults({
		scroller: d,
	});

	document.querySelectorAll('a[href]').forEach(anchor => {
		if (anchor.dataset.lenisAnchorBound === 'true') {
			return;
		}

		anchor.dataset.lenisAnchorBound = 'true';

		anchor.addEventListener('click', function (e) {
			const navigation = getInPageNavigation(this);

			if (!navigation) return;

			e.preventDefault();
			closeMenusForAnchor(this);

			lenis.scrollTo(navigation.target, {
				offset: isMobile() ? -80 : -100,
				immediate: false,
				duration: 1,
				easing: x =>
					x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2, // https://easings.net
			});

			const nextUrl = navigation.historyUrl;
			const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;

			if (nextUrl && currentUrl !== nextUrl) {
				window.history.pushState({}, '', nextUrl);
			}
		});
	});
}
export function getLenis(){
	return lenis;
}
export function destroyLenis() {}
